var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWoodHeating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 71,
    viewBox: "0 0 38 71",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.7271 7.5843H1V70.1299H36.7271V7.5843Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 14.3216H36.7348",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8165 60.7978H10.9558V66.5033H25.8165V60.7978Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2428 37.6906H8.24536V19.5806C8.24536 19.1957 8.4995 18.8646 8.86909 18.7645L10.4859 18.3256C15.8989 16.8703 21.5969 16.8703 27.0022 18.3256L28.619 18.7645C28.9886 18.8646 29.2428 19.1957 29.2428 19.5806V37.6906Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2429 26.0562H31.9995",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2429 29.883H31.9995",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2506 41.6252H8.49194V57.0325H29.2506V41.6252Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2429 47.4155H31.9995",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2429 51.2347H31.9995",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4109 45.6291V52.3588",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3186 34.0871C20.8345 33.91 21.9896 33.5096 22.7596 32.3623C23.2986 31.5615 23.3832 30.7839 23.4063 30.6145C23.5371 29.6443 23.0906 28.6664 22.8673 28.2429C22.7672 28.0581 22.7056 27.9965 22.644 27.9041C22.2898 27.342 22.1513 26.2949 23.1292 24.1158C22.236 24.2544 21.0886 24.5855 20.5342 25.5172C20.2262 26.0408 20.2649 26.4874 20.0724 26.5028C19.6566 26.5413 18.9558 24.47 18.848 22.445C18.7941 21.3593 18.9173 20.4507 19.0405 19.827C15.1598 21.4209 16.6612 25.7636 16.6612 25.7636C16.9692 27.4267 16.2148 28.2352 15.4525 28.1428C14.3052 28.0119 14.3436 25.3247 14.3436 25.3247C12.5495 26.1178 12.95 29.1438 12.95 29.1438C12.9731 29.6058 13.1039 31.6308 14.7363 33.063C15.4292 33.6713 16.1607 33.9639 16.6612 34.1102C17.2464 34.2873 18.6787 34.6415 20.2957 34.0871H20.3186Z",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2502 62.0682V65.102",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8452 62.0682V65.102",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4399 62.0682V65.102",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0349 62.0682V65.102",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6296 62.0682V65.102",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6538 0V7.58432H25.4932V0",
    stroke: "#322D60",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoodHeating);
export default __webpack_public_path__ + "static/media/woodHeating.fd0554789fcc9767bfd79df7d0781357.svg";
export { ForwardRef as ReactComponent };